<template>
  <v-app>
    <div class="mobile-header fix-header" v-if="$route.path !=='/alert/AlertPersonalSet' && $route.path !=='/alert/Sms'">
      <div class="banner_ flex">
        <div class="menu-box" @click="toggleNav">
          <img :src="mobileMenu ? close_mb : menu_mb"  class="mt-1"/>
        </div>

        <div class="flex mt-1">
          <div class="mb-title montserrat-subrayada-bold"
          @click="$getters.isLogin && $route.path !== '/home' ? $router.push('/home') : ''">
            CloudFarm
          </div>
        </div>

        <div class="mb_space">
        </div>
      </div>

      <transition name="menu-transition">
        <div class="nav" v-if="mobileMenu">
          <ul>
            <li v-for="(menu, index) in menus" :key="index">
              <div class="flex menu-text s-bt" @click="toggleSubMenu(index)"> 
                
                <div> {{ menu.title }}</div>
                <div>
                  <v-icon color="white">
                    {{ hoverIndex === index ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                  </v-icon>
                </div>
              </div>

              <transition name="submenu-transition">
                <div class="sub_menu" v-if="hoverIndex === index">
                  <div v-for="(sub, subIndex) in menu.subMenus" :key="subIndex" class="sub_menu_container">
                    <!-- 팝업으로 동작하는 메뉴 -->
                    <div v-if="sub.action" @click="sub.action" class="sub_menu_content flex">
                      <div class="sub_icon_box">
                        <img :src="sub.pic" class="sub_icon" />
                      </div>
                      <div class="sub_text mt-1">{{ sub.name }}</div>
                    </div>

                    <!-- 페이지로 이동하는 메뉴 -->
                    <router-link v-else-if="sub.link" :to="sub.link" class="router-link" @click.native="toggleNav">
                      <div class="sub_menu_content flex">
                        <div class="sub_icon_box">
                          <img :src="sub.pic" class="sub_icon" />
                        </div>
                        <div class="sub_text mt-1">{{ sub.name }}</div>
                      </div>
                    </router-link>

                    <!-- 링크나 액션 없는 경우 -->
                    <div v-else class="sub_menu_content flex">
                      <div class="sub_icon_box">
                        <img :src="sub.pic" class="sub_icon" />
                      </div>
                      <div class="sub_text mt-1">{{ sub.name }}</div>
                    </div>
                  </div>
                </div>
              </transition>

            </li>

            <div class="sub_text mt-3 mb-3 flex" style="color:white; font-weight:600; justify-content:end;">
              <div> {{ this.$getters.userName }} 님 </div>
              <button
                class="mt-2 login_btn" 
                v-show="$route.path !== '/user/login' &&
                        !$route.path.includes('/join') &&
                        !$route.path.includes('/user/findid') &&
                        !$route.path.includes('/user/findpassword')"
                >
                <img
                  class="login_icon"
                  alt="로그인"
                  v-show="!$getters.isLogin" 
                  :src="icon_login_white"
                  @click="login()"
                />
                
                <img
                  v-show="$getters.isLogin" 
                  class="login_icon ml-2"
                  alt="로그아웃"
                  location="bottom"
                  :src="icon_logout_white"
                  @click="logOut()"
                />
              </button>
            </div>

          </ul>
        </div>
      </transition>
    </div>

    <main class="container flex">
      <aside v-if="this.$getters.isLogin && $route.path !== '/user/login'" :class="['sidebar', { off: isOff }]" @mouseover="hoverOn" @mouseleave="hoverOff">
        <div class="side-margin">
          <div class="logo_container flex mt-1"
          @click="$getters.isLogin && $route.path !== '/home' ? $router.push('/home') : ''"
          @dblclick="$getters.isLogin && $getters.userInfo.grade < 'UT02' ? $router.push('/site') : ''">
            <img :src="logo_home" class="logo_image"/>

            <div class="company_info mt-1" v-if="!isOff">
              <div class="montserrat-subrayada-bold site-title"> CloudFarm </div>
              <div style="text-align:center; color:#005B96"> (주) 원스프링</div>
            </div>
          </div>

          <nav class="pc flex gnb">
            <ul class="gnb-inner">
              <li class="hover_color" v-for="(menu, index) in menus" :key="index" @mouseover="hoverIndex = index" @mouseleave="hoverIndex = null">
                <!-- 메인 메뉴 -->
                <div class="main_menu flex" v-if="mainService(menu)">
                  <div class="icon_box">
                    <img :src="menu.icon" class="icon mt-1" />
                  </div>
                  <span v-if="!isOff">{{ menu.title }}</span>
                </div>

                <!-- 하위 메뉴 -->
                <div class="sub_menu" v-if="hoverIndex === index">
                  <div v-for="(sub, subIndex) in menu.subMenus" :key="subIndex" class="sub_menu_container pl-5" v-show="($store.state.showMilk || sub.name != '착유')&& ($store.state.hideGrow || sub.name != '사육')">
                    <!-- 팝업으로 동작하는 메뉴 -->
                    <div v-if="sub.action" @click="sub.action" class="sub_menu_content flex">

                      <div class="sub_icon_box">
                        <img :src="sub.pic" class="sub_icon" />
                      </div>
                      <div class="sub_text mt-1">{{ sub.name }}</div>
                    </div>

                    <!-- 페이지로 이동하는 메뉴 -->
                    <router-link v-else-if="sub.link" :to="sub.link" class="router-link">
                      <div class="sub_menu_content flex">
                        <div class="sub_icon_box">
                          <img :src="sub.pic" class="sub_icon" />
                        </div>
                        <div class="sub_text mt-1">{{ sub.name }}</div>
                      </div>
                    </router-link>

                    <!-- 링크나 액션 없는 경우 -->
                    <div v-else class="sub_menu_content flex">
                      <div class="sub_icon_box">
                        <img :src="sub.pic" class="sub_icon" />
                      </div>
                      <div class="sub_text mt-1">{{ sub.name }}</div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </nav>


          <div class="nav-footer">
            <div class="flex">
              <img :src="people" class="icon_info" @click="$router.push('/user/editUser')"/>
              <span v-if="!isOff" class="member_info mt-2">{{ this.$getters.userName }} 님</span>

  
                <button
                class="mt-2 login_btn" 
                v-show="$route.path !== '/user/login' &&
                        !$route.path.includes('/join') &&
                        !$route.path.includes('/user/findid') &&
                        !$route.path.includes('/user/findpassword')"
                >
                <img
                  class="login_icon"
                  alt="로그인"
                  v-show="!$getters.isLogin" 
                  :src="icon_login"
                  @click="login()"
                />
                
                <img
                  v-show="$getters.isLogin" 
                  class="login_icon ml-2"
                  alt="로그아웃"
                  location="bottom"
                  :src="icon_logout"
                  @click="logOut()"
                />
              </button>
            </div>
          </div>

        </div>
      </aside>

      <div class="site_name" 
        v-show="$route.path !== '/user/login' && $route.path !== '/home' && $route.path !== '/' ">
        {{ getPageName(this.$route.name) }}
      </div>

      <div class="content">
        <router-view @farmChanged="farmChange" />

        <div v-if="popupType === 'alertPersonal'" class="popup">
          <AlertPersonal @close="closePopup" />
        </div>

        <div v-if="popupType === 'MtraceAgree'" class="popup">
          <MtraceAgree @close="closePopup" />
        </div>
        <!-- <SmsVerificationPopup v-if="popupType === 'smsVerification'" @close="closePopup" /> -->
      </div>
    </main>

    <v-footer app class="footer" v-if="this.$store.state.resMessage">
      <v-col class="text-center pa-1">
        <div v-if="$route.path !== '/user/login' && $route.path !== '/'">
        {{ this.$store.state.resMessage }}
        </div>
        <div v-else>
        CloudFarm Ver.2.0
        </div>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import Apis from '@/api/apis';
import AlertPersonal from "@/views/alert/AlertPersonalSet.vue";
import MtraceAgree from "@/views/alert/Sms.vue";

export default {
  name: 'App',
  components: {
    AlertPersonal,
    MtraceAgree
  },
  data(){
    return{
      menu_mb: require("@/assets/service_menu/menu-mobile-white.svg"),
      close_mb: require("@/assets/service_menu/close-btn.svg"),

      logo_home: require("@/assets/logo_simple.svg"),

      icon_logout: require("@/assets/common/icon_logout.svg"),
      icon_login: require("@/assets/common/icon_login.svg"),
      icon_logout_white: require("@/assets/common/icon_logout_white.svg"),
      icon_login_white: require("@/assets/common/icon_login_white.svg"),

      people :require("@/assets/common/people.svg"),

      isOff: true,
      services:{ trace:"", deodorizer:"", dailyrecord:"", fancontrol:"", medical:"", feed:"", esg:"", package:"" },
      userType:"",

      popupType: null,
      hoverIndex: null, 
      menus: [ ],
      mobileMenu:false,

    }
  },
  async created(){
    await this.typeSeriveUser();
    setInterval( () => {
      this.$store.commit("resMessage","")
    }, 2000);
  },
  computed: {
    setHomeBtn() {      
      return this.$getters.isLogin ? this.icon_home_white : this.logo_white;
    }, 
  },
  watch: {
  '$getters.isLogin'(newVal) {
      if (newVal) {
        this.resetMenus();     
        this.typeSeriveUser();  
      }
    },
  },
  methods:{
    async farmChange(farmInfo) {
        // farm_cd 기준으로 다시 서비스 가져오기
        await Apis.listAccesableServices({      // 제공 서비스 여부
          farm_cd: farmInfo.farm.code 
          },(res) => {
            this.services = res.data;
            // console.log(res)
            this.updateMenus();   
          }).catch( (err) => {  
            console.log("listAccesableServices API 호출 오류",err)
        })
    },
    openPopupWindow(url, title) {
      const width = 600;
      const height = 600;
      const left = (window.screen.width / 2) - (width / 2);
      const top = (window.screen.height / 2) - (height / 2);

      // 새 창 열기
      window.open(
        url,
        title,
        `width=${width},height=${height},top=${top},left=${left},scrollbars=yes,resizable=no`
      );
    },
    hoverOn() {
      this.isOff = false;
    },
    hoverOff() {
      this.isOff = true;
    },
    toggleNav(){
      this.mobileMenu = !this.mobileMenu;
    },
    toggleSubMenu(index) {
      if (this.hoverIndex === index) {
        this.hoverIndex = null; // 동일 메뉴 클릭 시 닫기
      } else {
        this.hoverIndex = index; // 클릭한 메뉴 열기
      }
    },
    async typeSeriveUser(){
      if (this.$getters.isLogin) {
        await Apis.listAccesableServices({      // 제공 서비스 여부
          },(res) => {
            this.services = res.data;
            // console.log(res)
            this.updateMenus();   
          }).catch( (err) => {  
            console.log("listAccesableServices API 호출 오류",err)
        }),

        await Apis.getUserType({          //useType
          },(res) => {  
            this.userType = res.data
            // console.log(res)
            this.updateMenus();   
          }).catch( (err) => {  
            console.log("getUserType API 호출 오류",err)
        })
      }
    },
    updateMenus(){
      const services = this.services;

      const allMenus = [
      {
          title: "환경 모니터",
          serviceKey: "base",
          icon: require("@/assets/service_menu/basic.svg"),
          subMenus: [   
            { name: "기상 정보", link: "/weather", pic:require("@/assets/sub_menu/base_weather.svg") },
            { name: "환경센서 모니터", link: "/summary", pic:require("@/assets/sub_menu/base_sensor.svg")},
            { name: "에너지 모니터", link: "/watt", pic:require("@/assets/sub_menu/base_energy.svg")}
          ]
        },
        {
          title: "사육 / 출하",
          serviceKey: "trace",
          icon: require("@/assets/service_menu/dailyrecord.svg"),
          subMenus: [   
            { name: "사육", link: "/trace/grow", pic:require("@/assets/sub_menu/grow_grow2.svg")},
            { name: "출하", link: "/trace/ship", pic:require("@/assets/sub_menu/grow_sell.svg")},
            { name: "시장", link: "/trace/market", pic:require("@/assets/sub_menu/grow_market.svg")},
            { name: "착유", link: "/trace/milk", pic:require("@/assets/sub_menu/grow_milk.svg")}
          ]
        },
        {
          title: "환기",
          serviceKey: "fancontrol",
          icon: require("@/assets/service_menu/fan.svg"),
          subMenus:[   
            { name: "환기 현황 및 제어", link: "/controlMonitroing", pic:require("@/assets/sub_menu/fan_fanset.svg") },
            { name: "계절별 환기 설정", link: "/controlTable", pic:require("@/assets/sub_menu/fan_autoset.svg") }
          ]
        },
        {
          title: "악취",
          serviceKey: "deodorizer",
          icon: require("@/assets/service_menu/deodorizer.svg"),
          subMenus:[   
            { name: "악취 현황 및 제어", link: "/deodorizerSetMonitoring", pic:require("@/assets/sub_menu/deodorizer_set.svg") },
            { name: "기계실 모니터", link: "/deodorizerMonitoring", pic:require("@/assets/sub_menu/deodorizer_machine.svg")   }
          ]
        },
        {
          title: "ESG",
          serviceKey: "esg",
          icon: require("@/assets/service_menu/esg.svg"),
          subMenus: [   
            { name: "전력사용 및 요금현황", link: "/esg/energy", pic:require("@/assets/sub_menu/esg_energycost.svg")  },
            { name: "온실 가스 배출 현황", link: "/esg/esgMonitor", pic:require("@/assets/sub_menu/esg_ch4.svg") },
            // { name: "저탄소 축산물 인증제", link: "/esg/carbonaid", pic:require("@/assets/sub_menu/esg_lowcarbon.svg") }
          ]
        },
        {
          // 패키지 개별 화면 완성되면 action 지우고 -> raw데이터 팜인포 기존걸로 수정
          title: "패키지",
          serviceKey: "package",
          icon: require("@/assets/service_menu/package.svg"),
          subMenus: [
            { name: "착유기", link: "/trace/milk", pic: require("@/assets/sub_menu/grow_milk.svg"), code: "PC04" },
            { name: "송풍기", link: "/package/Fan", pic: require("@/assets/sub_menu/package_fan.svg"), code: "EC01" },
            { name: "냉방기", link: "/package/Airconditioner", pic: require("@/assets/sub_menu/package_coolfan.svg"), code: "EC08" },
            { name: "송아지포유기", link: "", pic: require("@/assets/sub_menu/package_calf.svg"), code: "AF14",
              action: () => {
                const currentFarm = this.$store.state.farmInfo;
                sessionStorage.setItem("pack_farm", JSON.stringify(currentFarm));

                this.$router.push({
                  name: "rawData",
                  params: {
                    typeCode: "AF14"
                  }
                });
              }
             },
            { name: "발정탐지기", link: "package/Estrusdetector", pic: require("@/assets/sub_menu/package_alert.svg"), code: "BI01", },
            { name: "음수관리기", link: "/package/AutoWater", pic: require("@/assets/sub_menu/package_water.svg"), code: "AF02"},
            { name: "TMR배합기", link: "", pic: require("@/assets/sub_menu/package_feed.svg"), code: "AF13",
              action: () => {
                const currentFarm = this.$store.state.farmInfo;
                sessionStorage.setItem("pack_farm", JSON.stringify(currentFarm));
                
                this.$router.push({
                  name: "rawData",
                  params: {
                     typeCode: "AF13"
                  }
                });
              }
             }
          ]
        },
        {
          title: "알림",
          serviceKey: "base",
          icon: require("@/assets/service_menu/alert.svg"),
          subMenus: [   
            { name: "알림설정", link: "/alert/AlertSet", pic:require("@/assets/sub_menu/set_alert.svg")  },
            { name: "알림 수신 여부",action: () => this.openPopupWindow('/alert/AlertPersonalSet', '알림 수신 여부'), pic:require("@/assets/sub_menu/set_message.svg") },
            // { name: "알림 발송 내역", link: "/alert/AlertSet", pic:require("@/assets/sub_menu/alert_history.svg") }
          ]
        },
        {
          title: "환경설정",
          serviceKey: "base",
          icon: require("@/assets/service_menu/setting.svg"),
          subMenus: [   
            { name: "알림설정", link: "/alert/AlertSet", pic:require("@/assets/sub_menu/set_alert.svg")  },
            { name: "정보설정", link: "/infoSet", pic:require("@/assets/sub_menu/set_info.svg") },
            { name: "알림 수신 여부",action: () => this.openPopupWindow('/alert/AlertPersonalSet', '알림 수신 여부'), pic:require("@/assets/sub_menu/set_message.svg") },
            { name: "SMS 본인인증", action: () => this.openPopupWindow('/alert/Sms'), pic:require("@/assets/sub_menu/set_sms.svg") }
          ]
        },
        {
          title: "고객관리",
          serviceKey: "base",
          icon: require("@/assets/service_menu/client.svg"),
          subMenus: [   
            { name: "공지사항", link: "/client/notice", pic:require("@/assets/sub_menu/client_notice.svg")  },
            { name: "A/S접수", link: "/client/asRegister", pic:require("@/assets/sub_menu/client_as.svg") },
          ]
        }
      ];

      this.menus = allMenus.filter(menu => {
        const key = menu.serviceKey;
        const isPackage = key === "package";

        // 패키지인 경우는 배열 여부로 확인
        if (isPackage) {
          const packageList = Array.isArray(services.package) ? services.package : [];
          if (packageList.length === 0) return false;

          const packageCodes = packageList.map(p => p.code);

          // 서브메뉴만
          menu.subMenus = menu.subMenus.filter(sub => packageCodes.includes(sub.code));
          return menu.subMenus.length > 0;
        }

        // 나머지 일반 메뉴는 true/false 여부
        return services[key] === true;
      });
    },
    resetMenus() {
      // 메뉴 초기화
      this.menus = [];

      // 서비스상태 초기화
      this.services = {
        trace: false,
        base: false,
        package: [],
        dailyrecord: false,
        fancontrol: false,
        deodorizer: false,
        medical: false,
        feed: false,
        esg: false
      };

      // 사용자 타입 초기화
      this.userType = "";
    },

    mainService(menu){
      return this.services[menu.serviceKey]; 
    },
    handleItemClick(method) {
      if (this[method]) {
        this[method]();
      }
    },
    Pigro(){
      window.open('https://pigro.onespring.co.kr/setinfo', '_blank');
    },
    login() {
      this.$router.push("/user/login").then(async () => {
        await this.typeSeriveUser();
        this.typeSeriveUser();
      });
    },
    logOut() {
      if (this.$getters.isLogin) {
        var logoutConfirm = confirm("로그아웃 하시겠습니까?");
        if (logoutConfirm) {

          this.$dispatch("logout", {
            session_id: this.$getters.sessionId,
            account: this.$getters.userInfo.account,
            user_name: this.$getters.userInfo.name,
          }).then(() => {
            this.$router.push("/user/login");
            this.resetMenus();
            }).catch( (err) => {  // 개별 API 오류 처리 예제
            console.log("LogOut 호출 오류2",err);
            this.$router.push("/user/login");
            this.resetMenus();
            }) 
        }
      } else {
        if (this.$route.path !== "/user/login") this.$router.push("/user/login");
      }
    },
    myInfo() {
      if (this.$route.path !== "/user/myinfo") this.$router.push("/user/myinfo")
    },
    goto(path) {
      // console.log("PATH",path);
      this.drawer_ = false;
      this.$router.push(path);
    },
    toggleDrawer() {
      this.$router.push("/")
      // this.$commit("drawer", !this.drawer);
    },
    getPageName(pageName) {
      // console.log(pageName);
      switch (pageName) {
        case "/":
          return "PIGRO";
        case "Summary":
          return "환경센서 모니터";
        case "infoSet":
          return "정보설정";
        case "Barometer":
          return "환경센서 지표조회";
        case "Watt":
          return "에너지 모니터";
        case "Energy":
          return "전력 사용 및 요금 현황";
        case "Weather":
          return "날씨 정보";
        case "Ship":
          return "출하";
        case "Grow":
          return "사육";
        case "Market":
          return "시장";
        case "NewMilk":
          return "착유";
        case "Esg":
          return "온실가스 배출현황";
        case "ControlMonitoring":
          return "환기현황";
        case "ControlSetting":
          return "환기제어";
        case "ControlTable":
          return "계절별 환기 설정";
        case "DeodorizerMachineRoom":
          return "기계실 모니터";
        case "DeodorizerSetting":
          return "악취 제어 설정";
        case "DeodorizerSetMonitoring":
          return "악취 제어 현황";
        case "EditUser":
          return "내 정보 수정";
        case "Home":
          return "ONESPRING";
        case "HomeCard":
          return "PIGRO";
        case "MainMenu":
          return "바로가기 맵";
        case "Login":
          return "ONESPRING";
        case "JoinAgree":
          return "정보수집동의";
        case "JoinInfo":
          return "가입정보";
        case "FindAccount":
          return "ID 찾기";
        case "FindPassword":
          return "비밀번호 찾기";
        case "MyInfo":
          return "내정보 수정";
        case "ChangePW":
          return "비밀번호 변경";
        case "ComponentTest":
          return "부자되세요";
        case "base_Summary":
          return "환경 센서 모니터링";
        case "base_Barometer":
          return "과거데이터";
        case "base_WattageDetail":
          return "에너지 사용량 모니터링";
        case "control_SensorSummary":
          return "환기 센서 모니터링";
        case "control_Barometer":
          return "과거데이터";          
        case "ControlSummary":
          return "환기 제어 모니터링";
        case "ControlSet":
          return "환기 제어 설정";
        // case "ControlTable":
        //   return "계절별 환기 설정";
        case "deodorizer_SensorSummary":
          return "악취 센서 모니터링";
        case "deodorizer_Barometer":
          return "과거데이터";  
        case "DeodorizerMonitoring":
          return "악취 제어 모니터링";
        case "DeodorizerSet":
          return "악취 제어 설정";
        case "DeodorizerDviceMonitoring":
          return "기계실 모니터링";
        case "AlertSet":
          return "알림 설정";
        case "AlertPersonalSet":
          return "개인 수신 설정";
        case "GrowData":
          return "사육 데이터";
        case "ShipData":
          return "출하 데이터";
        case "MarketInfo":
          return "시장 정보";
        case "EnergyCost":
          return "에너지 요금 모니터링";
        case "base_Weather":
          return "기상 모니터링";
        case "MonitorEsg":
          return "배출량 모니터링";
        case "LowAvailable":
          return "저탄소 축산물 인증제 지원자격";
        case "Lowcarbon":
          return "저탄소 축산물 인증제 지원여부";
        case "Notice":
          return "공지사항";
        case "AsRegister":
          return "A/S 접수";
        case "AsList":
          return "A/S 내역";
        case "ElectAi":
          return "전력 소비량 예측";
        case "NewAlertSet":
          return "알림 설정";
        case "Autowater":
          return "음수관리기 현황";
        case "rawData":
          return "원시데이터 조회";
        case "Estrusdetector":
          return "발정탐지기 현황";
        case "Airconditioner":
          return "냉방기 현황";
        case "Fan":
          return "송풍팬 현황";
        default:
          return pageName;
      }
    },
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Montserrat+Subrayada:wght@400;700&display=swap');
.montserrat-subrayada-bold {
  font-family: "Montserrat Subrayada", sans-serif;
  font-weight: 700;
  font-style: normal;
}

@import './style/base.scss';
.flex{
  display: flex;
}
aside{
  padding-left:15px;
}
.container{
  margin-top:-10px;
}
.sidebar {
  flex: 0 0 80px !important; /* 기본 사이드바 너비를 고정 */
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 80px; 
  background-color: $menu-color;
  transition: width 0.3s ease;
  overflow: hidden;
  z-index: 99;
}

.sidebar:hover {
  flex: 0 0 250px;
  width: 250px; 
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  align-items: flex-start;
}
.site-title{
  color:$main-color;
  font-size:1.1rem;
}
.logo_container{
  cursor: pointer;
  width:50px;
  height:50px;
  background-color:white;
  border-radius: 50%;
  align-items: center;
}
.logo_image{
  width:55px !important;
  height:55px !important;
  margin-top:0;
}
.gnb{
  margin-top:120px !important;
}
.gnb-inner {
  list-style: none;
}

.gnb-inner li {
  align-items: center;
  margin-top:15px !important;
  transition: all 0.5s ease;
}

.icon_box {
  width: 55px;
  height: 55px;
  background-color: white;
  border-radius: 5px;
  text-align: center;
}
.hover_color:hover{
  background-color:$main-color;
  border-radius: 5px;
  box-shadow: none; /* 경계선 제거 */
  .icon_box{
    background-color: $main-color;
  }
  .icon{
    filter: invert(89%) sepia(45%) saturate(0%) hue-rotate(58deg) brightness(112%) contrast(101%);
  }
  .main_menu span{
    color:white;
  }
}
.icon {
  width: 45px !important;
  height: 45px !important;
}

.main_menu {
  align-items: center;
}
.main_menu span , .company_info {
  margin-left: 10px;
  white-space: nowrap;
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s linear 0.3s, opacity 0.3s ease;
  width:150px;
  margin-left:10px !important;
  font-weight:600;
}
.member_info , .login_btn {
  margin-left: 20px !important;
  white-space: nowrap;
  visibility: hidden;
}
.company_info{
  line-height: 15px;
  font-size:15px;
  letter-spacing: -1px;
  font-weight: 600;
}
.sidebar:hover .main_menu span,.company_info ,.member_info ,.login_icon{
  visibility: visible;
  opacity: 1;
  transition-delay: 0s;
}

.nav-footer {
  position: absolute;
  bottom: 18px;
  left: 0;
  width: 100%;
  margin-left:15px !important;
}

.sub_menu {
  display: none;
  border-radius: 0 0 5px 5px;
  background-color:white;
  transition: all 0.5s ease;
}
li:hover .sub_menu {
  display: block; 
}
.router-link{
  text-decoration: none !important;
  cursor: pointer;
  color: black !important; 
}
.sub_menu_content{
  padding:10px;
}
.sub_menu_container:hover:last-child{
  border-radius: 0 0 5px 5px;
}
.sub_menu_container:hover{
  background-color:$darkgray-color !important;
}
.sub_icon_box{
  border:1px solid #D7D7D7;
  border-radius: 7px;
  padding:2px;
  width:30px;
  height:30px;
  text-align: center;
  margin-right:10px;
}
.sub_icon{
  width:25px;
  height:25px;
}
.sub_menu_container , .sub_icon_box ,.sub_text{
  transition: all 0.5s ease;
}
.sub_menu_container:hover .sub_icon_box{
  border: 1px solid $main-color;
}
.sub_menu_container:hover .sub_icon{
  filter: invert(15%) sepia(96%) saturate(3523%) hue-rotate(190deg) brightness(93%) contrast(103%);
}
.sub_menu_container:hover .sub_text{
  color:$main-color;
}
.icon_info{
  width:40px;
  height:40px;
  cursor: pointer;
}
.login_icon{
  width:25px;
  height:25px;
}
.content {
  flex: 1 !important; /* 남은 공간을 모두 차지 */
  margin-left:75px !important;
}

.site_name {
  position: fixed;  
  right: 0; 
  top:10px;       
  background-color: $main-color;  
  color:white;
  font-weight:$bold-weight;
  padding: 15px 30px 15px 15px;  
  border-radius: 10px 0 0 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); 
  z-index: 1000;   
}

.footer{
  height:2rem !important;
  background-color: $menu-color !important;
  color:$main-color !important;
  font-weight: 600;
  line-height:5px;
}
.mobile-header{
  display:none;
}
.nav {
  background-color: #005B96;
  position: absolute;
  top: 50px; /* 헤더 아래에 위치 */
  left: 0;
  width: 100%;
  height: auto;
  z-index: 1000;
}

.nav ul {
  list-style: none;
  padding: 0;
}

.nav ul li {
  padding: 10px;
  border-bottom: 1px solid white;
}

.nav ul li a {
  color: white;
  text-decoration: none;
}
.menu-transition-enter-active,
.menu-transition-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.menu-transition-enter,
.menu-transition-leave-to {
  opacity: 0;
  transform: translateY(-10px); /* 살짝 위로 올라가는 효과 */
}

/* 서브메뉴 애니메이션 */
.submenu-transition-enter-active,
.submenu-transition-leave-active {
  transition: max-height 0.3s ease, opacity 0.3s ease;
}

.submenu-transition-enter,
.submenu-transition-leave-to {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}
@media screen and (max-width: 768px) {
  /* 모바일 스타일 적용 */
  // .footer{
  //   display: none !important;
  // }
  aside, .site_name{
    display:none;
  }
  .mobile-header{
    display:block;
    width: 100%;
    height: 50px;
    background-color:$main-color;
    padding: 10px;
    // line-height: 60px;
  }
  .fix-header{
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 2000;
  }
  .banner{
    // background-color: ;
    display:flex;
    align-items: center;

    justify-content: space-between;
  }
  main{
    margin-top:60px;
  }
  .container{
    margin-top:40px;
  }
  .menu-box{
    width:30px;
    height:30px;
  }
  .content {
    flex: 1 !important; /* 남은 공간을 모두 차지 */
    margin-left:-12px !important;
  }
  .mb-title{
    color:white;
    letter-spacing: -1px;
  }
  .mb_space{
    width:20px;
  }
  .menu-text{
    color:white;
    font-weight:$bold-weight;
  }
  .login_icon{
    margin-top:-25px;
    margin-right:10px;
  }
  .login_btn{
    margin-left:5px !important;
  }
}

</style>